
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Cell from 'vux/src/components/cell/index.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Marquee from 'vux/src/components/marquee/marquee.vue'
import MarqueeItem from 'vux/src/components/marquee/marquee-item.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import global from '../../static/js/global.js'
import loadPage from '../components/loadingPage'
export default {
components: {
Flexbox,
FlexboxItem ,
PopupPicker,
Group ,
Swiper,
Cell,
SwiperItem,
XImg,
Alert,
Marquee,
MarqueeItem,
LoadMore,
loadPage,
XHeader
},
data(){
return {
loopList:[],
communityName:'    ',
funcEnter:'',
temp:[0,1,2],
advList:[],
communityId:'',
openid:this.$router.history.current.query.openid,
phone:this.$router.history.current.query.phone,
show:false,
newList:[],
comnCodes:'',
show_loading:false
}
},
beforeMount(){
this.show_loading = true;
/*正式环境*/
let urlother = global.host + 'home/home/' + this.$router.history.current.query.openid + '/' + this.$router.history.current.query.phone;
/*测试环境*/

this.$http.get(urlother).then(function(res){
if(res.body.result){
/*传给商家入驻的参数*/
this.comnCodes = res.body.result.loopPictureList[0].comnCode;

this.communityName = res.body.result.community.comnName
this.communityId = res.body.result.community.comnCode
this.$http.get(global.host + 'home/findimportnotice?comnCode=' + this.communityId).then(function(res){
console.log(res)

let data = res.body.result;
for(let i = 0 ; i < data.length ; i++){
let temp = new Object()
temp.title = data[i].newsTitle;
temp.id = data[i].newsId;
this.newList.push(temp)
}
},function(err){
console.log(err)
})



/*图片轮播数据处理*/
let loopPictureList = res.body.result.loopPictureList;
this.loopList = new Array()
for(let i = 0 ; i < loopPictureList.length ; i++){
this.loopList[i] = loopPictureList[i];



}
/*功能入口数据处理*/
this.funcEnter = new Array();
let funcList = res.body.result.funcList;
let beginIndex = 0;
if(funcList.length <= 12){
for(let i = 0 ; i < funcList.length ; i++){
if(i == 0){
this.funcEnter[beginIndex] = new Array()
this.funcEnter[beginIndex][(i % 4)] = new Object;
}else if(i != 0 && i % 4 == 0){
beginIndex ++;
this.funcEnter[beginIndex] = new Array()
this.funcEnter[beginIndex][(i % 4)] = new Object;
}else{
this.funcEnter[beginIndex][(i % 4)] = new Object;
}
for(let prop in  funcList[i]){
if(prop == 'icon'){
this.funcEnter[beginIndex][(i % 4)][prop] = funcList[i][prop];
}else{
this.funcEnter[beginIndex][(i % 4)][prop] = funcList[i][prop];
}
}
}
}else{
for(let i = 0 ; i < 11 ; i++){
if(i == 0){
this.funcEnter[beginIndex] = new Array()
this.funcEnter[beginIndex][(i % 4)] = new Object;
}else if(i != 0 && i % 4 == 0){
beginIndex ++;
this.funcEnter[beginIndex] = new Array()
this.funcEnter[beginIndex][(i % 4)] = new Object;
}else{
this.funcEnter[beginIndex][(i % 4)] = new Object;
}
for(let prop in  funcList[i]){
if(prop == 'icon'){
this.funcEnter[beginIndex][(i % 4)][prop] = funcList[i][prop];
}else{
this.funcEnter[beginIndex][(i % 4)][prop] = funcList[i][prop];
}
}
}
let more = {
icon: global.imgUrl + '/image/more.png',
title : '更多' ,
remark : '更多入口' ,
link : '',
show : false
}
this.funcEnter[beginIndex].push(more);
}
/*广告位数据处理*/
this.advList = new Array;
let adv = res.body.result.advertisementList;
for(let i = 0 ; i < adv.length ; i++){
this.advList[i] = new Object;
for(let prop in  adv[i]){
if(prop == 'image'){
this.advList[i][prop] = adv[i][prop];
}else{
this.advList[i][prop] = adv[i][prop];
}
}
}
this.show_loading = false;
}
},function(err){
this.show_loading = false;
console.log(err);
})
},
methods:{
showAlert(url){
if(url == '/'){
this.show = true
}else if(url.indexOf('tel:') != -1){
window.location.href = url;
}
},
gotoNotice(id){
this.$router.push({path:'/notice',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,id:id,communityId:this.communityId}})
}
},
mounted(){
if(this.$router.history.current.path == "/"){
if(global.host.indexOf('yaokesong')==-1){
document.title = "优每家";
}else{
document.title = "耀客松平安社区";
}

}
}
}



// WEBPACK FOOTER //
// ./src/components/index.vue